/**
 * Après un déploiement, un onglet resté ouvert sur l'ancienne version demande des fichiers (morceaux
 * chargés à la demande) qui n'existent plus sur le serveur. On recharge la page **une seule fois** pour
 * récupérer la nouvelle version ; la garde en sessionStorage évite toute boucle de rechargement.
 */
const KEY = 'stale-version-reload-at';
const GUARD_MS = 30_000;

export function isStaleChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '');
  return /dynamically imported module|Importing a module script failed|error loading dynamically imported module|Failed to fetch dynamically/i.test(
    message,
  );
}

/** Recharge la page si aucun rechargement de ce type n'a eu lieu depuis peu ; renvoie vrai si c'est le cas. */
export function reloadForNewVersion(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? '0');
    if (Date.now() - last < GUARD_MS) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // Stockage indisponible : on recharge quand même, une fois par événement.
  }
  window.location.reload();
  return true;
}

/** Écoute l'événement émis par Vite quand un morceau de l'application ne se charge pas. */
export function installStaleVersionGuard(): void {
  window.addEventListener('vite:preloadError', (event) => {
    if (reloadForNewVersion()) event.preventDefault();
  });
}
